module.exports = __webpack_public_path__ + "img/rag-icon.5ec83e57.png";